import React from "react";

// Ícone da fonte "Material Icons" (carregada em public/index.html). Substitui o
// `Icon` do @mui/material, que arrastava o MUI + emotion inteiros para o bundle
// inicial só por causa disto. Mesma API de uso: <Icon fontSize="inherit"
// className style>nome_do_icone</Icon>, e os mesmos padrões visuais do MUI
// (1em × 1em, `overflow: hidden`, não selecionável, 1,5 rem por padrão).
// A base fica em CSS com especificidade ZERO (styles/animations.css §6), então
// qualquer classe ou `style` da tela vence, como antes.
const SIZES = { small: "1.25rem", medium: "1.5rem", large: "2.1875rem" };

export default function MaterialIcon({
  children,
  className = "",
  style,
  fontSize,
  baseClassName = "material-icons",
  ...rest
}) {
  const sized =
    fontSize && fontSize !== "inherit" && SIZES[fontSize]
      ? { fontSize: SIZES[fontSize] }
      : fontSize === "inherit"
        ? { fontSize: "inherit" }
        : null;
  return (
    <span
      className={`mi-root ${baseClassName} ${className}`.trim()}
      aria-hidden="true"
      style={sized || style ? { ...sized, ...style } : undefined}
      {...rest}
    >
      {children}
    </span>
  );
}
